import * as React from "react";
import Cell from "source/app/presentation/MainPanel/Dreams/Cell/Cell";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DisplayLosingStreak({
    badStreakLength,
}: {
    badStreakLength?: number;
}) {
    if (badStreakLength === undefined || badStreakLength === 0) {
        return null;
    }

    const styleClass = StyleClass(`losingStreak_${badStreakLength}`, {
        fontSize: `15px`,
        opacity: 0.2,
        color: `yellowgreen`,
    });

    const streakText = `-${badStreakLength}`;

    return <Cell classes={styleClass}>{streakText}</Cell>;
}

const maxStreakLength = 6;
